// ---
import React from "react";
import {connect} from "react-redux";
import {formValueSelector, reduxForm} from "redux-form";
import {ff, form, Icon, utils} from "@mc/mc-legacy";
import {Card, CardBody, CardHeader, Col, Row} from "reactstrap";
import ConfigurationField from "../field/ConfigurationField";
import * as findCombinationsActions from "../../actions/findCombinationsActions";
import ApprovalField from "../field/ApprovalField";
import TypeCombinationField from "../field/TypeCombinationField";
import SignersField from "../field/SignersField";
import TypeSign from "../../api/gen/qsign/types/TypeSign";
import * as TypeSignInfo from "../../api/TypeSignInfo";
import classNames from "classnames";

const Form = form.Form;
const FormBody = form.FormBody;
const FormActions = form.FormActions;

const validate = (formData) => {
    const errors = {};

    if (!formData.name) {
        errors.name = "Musí být vyplněn název";
    }

    if (!formData.signPracovnikId) {
        errors.signPracovnikId = "Musí být vyplněn podepisující";
    }
   if(formData.description&& formData.description.length>1000){
        errors.description = "Poznámka může mít maximálně 1000 znaků";
    }

    if (formData.signUntil) {
        const signUntil = new Date(formData.signUntil);
        const today = new Date();
        signUntil.setHours(0, 0, 0, 0);
        today.setHours(0, 0, 0, 0);
        if (signUntil < today) {
            errors.signUntil = "Termín zpracování nesmí být v minulosti";
        }
    }

    if (formData.files) {
        if (formData.files.length === 0) {
            errors.files = "Musí být vybrán alespoň jeden PDF nebo PDF/A soubor k podpisu";
        } else {
            let sign = 0;
            formData.files.forEach(f => {
                if (!f.attachment) {
                    sign++;
                }
            });
            if (sign === 0) {
                errors.files = "Musí být vybrán alespoň jeden PDF nebo PDF/A soubor k podpisu";
            }
        }
    }

    switch (formData.typeSign) {
        case TypeSign.CUSTOM:
            if (!formData.signers || formData.signers.length == 0) {
                errors.signers = "Musí být vyplněn alespoň jeden podepisující";
            } else {
                const ids = formData.signers.map(p => p.pracovnikId);
                let idsDeduplicate = [];
                ids.forEach(function(item) {
                    if(idsDeduplicate.indexOf(item) < 0) {
                        idsDeduplicate.push(item);
                    }
                });
                if (idsDeduplicate.length !== formData.signers.length) {
                    errors.signers = "Každý podepisující může být vybrán maximálně jednou";
                }
            }
            if (!formData.typeCombinationId) {
                errors.typeCombinationId = "Musí být vyplněna kombinace";
            }
            break;
        case TypeSign.SIGN_COMBINATION:
            if (!formData.signConfigurationId) {
                errors.signConfigurationId = "Musí být vyplněna podpisová konfigurace";
            }
            break;
    }

    return errors;
};

const itemTypeList = TypeSignInfo.getValues().map(value => ({id: value, name: TypeSignInfo.getCaption(value) }));

/**
 * Formulář nového požadavku k hromadnému podepsání dokumentů.
 */
class PreNovyPozadavekForm extends React.Component {

    static formName = "preNovyPozadavekForm";

    onChangeKonfigurace = () => {
        if (this.props.typeSign === TypeSign.SIGN_COMBINATION) {
            this.props.change("signConfigurationId", null);
        } else if (this.props.typeSign === TypeSign.CUSTOM) {
            this.props.change("typeCombinationId", null);
            this.props.change("signConfigurationId", null);
        }
    }

    render() {
        const {onClose, handleSubmit, submitting, KombinaceList, typeCombinationItems, typeSign, files} = this.props;
        const commons = {
            disabled: submitting,
        };
        const items = [];
        KombinaceList.filteredRows &&
        KombinaceList.filteredRows.forEach((item) => {
            items.push({id: item.name, name: item.name});
        });

        const cls = classNames(["w-100", "h-100", "dropzone-label-wrapper"], {
            "drag-active": false,
        });
        return (
            <Form onSubmit={handleSubmit} className={"novy-pozadavek-form"}>
                <FormBody cards>
                    <Row noGutters>
                        <Col xs={6}>
                            <Card>
                                <CardHeader>
                                    <h2>Nahrané soubory</h2>
                                </CardHeader>
                                <CardBody>
                                    <div className={'items-list bordered'}>
                                        {files && files.length > 0 &&
                                            files.map((fileUploaded, index) => {
                                                return (<CardBody className={cls}>
                                                    {fileUploaded.name}
                                                </CardBody>);
                                            })
                                        }
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col xs={6}>
                            <Card>
                                <CardHeader>
                                    <h2>Údaje požadavku</h2>
                                </CardHeader>
                                <CardBody>
                                    <ff.String name={"name"} label={"Název"} required {...commons} />
                                    <ff.Base
                                        componentClass={ApprovalField}
                                        name={"approval"}
                                        label={"Schvalování"}
                                        {...commons}
                                    />
                                    <ff.Autocomplete disabled={submitting} useIdAsValue={true} required
                                                     name="typeSign" label="Konfigurace požadavku"
                                                     items={itemTypeList} onChange={this.onChangeKonfigurace}/>

                                    {typeSign === TypeSign.CUSTOM &&
                                        <>
                                            <ff.Base
                                                componentClass={SignersField}
                                                name={"signers"}
                                                label={"Podepisujicí"}
                                                required
                                                {...commons}
                                            />
                                            <ff.Base
                                                componentClass={TypeCombinationField}
                                                name={"typeCombinationId"}
                                                label={"Kombinace podepsání"}
                                                items={typeCombinationItems}
                                                required
                                                {...commons}
                                            />
                                        </>
                                    }

                                    {typeSign === TypeSign.SIGN_COMBINATION && <ff.Base
                                        componentClass={ConfigurationField}
                                        name={"signConfigurationId"}
                                        label={"Volba podpisové konfigurace"}
                                        required
                                        {...commons}
                                    />}
                                    {<ff.SimpleDate name={"signUntil"} label={"Termín"} {...commons} />}
                                    <ff.Textarea rows={10} name={"description"} label={"Poznámka"} {...commons} />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </FormBody>
                <FormActions onClose={onClose} disabled={submitting} submitButton={"Odeslat"} cancelButton/>
            </Form>
        );
    }
}

function mapStateToProps(state) {
    const selector = formValueSelector(PreNovyPozadavekForm.formName);
    return {
        files: selector(state, "files"),
        KombinaceList: utils.storeFromArea(state, findCombinationsActions.KOMBINACE_LIST),
        typeSign: selector(state, "typeSign"),
        signers: selector(state, "signers"),
        typeCombinationId: selector(state, "typeCombinationId"),
        signConfigurationId: selector(state, "signConfigurationId"),
    };
}

const reduxFormObj = reduxForm({
    form: PreNovyPozadavekForm.formName,
    validate: validate,
})(PreNovyPozadavekForm);
export default connect(mapStateToProps)(reduxFormObj);
